/**
 * @description A singleton that should manage the memory of an instance of a viewer
 */

import { CacheType } from './cache/cache-element';
// @ts-ignore
import State from './state';

export class MemoryManager {
  static getInstance() {
    if (!MemoryManager.instance) {
      MemoryManager.instance = new MemoryManager();
    }

    return MemoryManager.instance;
  }
  private static instance: MemoryManager;
  private allocatedMemory: { [key in CacheType]?: number } = {};
  private startDate = new Date();
  private diffChanges: any = {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  allocate(size: number, type: CacheType = 'Unknown') {
    this.allocatedMemory[type] = this.allocatedMemory[type] ?? 0;

    const entry = this.createEntry(this.allocatedMemory[type]! + size);
    this.allocatedMemory[type] =
      (this.allocatedMemory[type] && this.allocatedMemory[type]! + size) || size;
    Array.isArray(this.diffChanges[type])
      ? this.diffChanges[type].push(entry)
      : (this.diffChanges[type] = [entry]);
  }

  release(size: number, type: CacheType = 'Unknown') {
    this.allocatedMemory[type] = this.allocatedMemory[type] ?? 0;
    const entry = this.createEntry(this.allocatedMemory[type]! - size);
    this.allocatedMemory[type]! -= size;
    Array.isArray(this.diffChanges[type])
      ? this.diffChanges[type].push(entry)
      : (this.diffChanges[type] = [entry]);
  }

  getAvailableMemory() {
    return State.getValue('totalMemory') - this._calculateTotaUsedMemory();
  }

  getTotalAllocatedMemory() {
    return this._calculateTotaUsedMemory();
  }

  getMemoryTimeline() {
    return {
      start: this.startDate,
      timeline: this.allocatedMemory,
    };
  }

  clearDiffs() {
    const diffs = this.diffChanges;
    this.diffChanges = {};
    return diffs;
  }

  getTotalMemory() {
    return State.getValue('totalMemory');
  }

  createEntry(size: number) {
    return {
      time: Date.now(),
      size: size / (1024 * 1024),
    };
  }

  reset() {
    this.allocatedMemory = {};
    this.startDate = new Date();
  }

  _calculateTotaUsedMemory() {
    return (Object.keys(this.allocatedMemory) as CacheType[]).reduce(
      (prev: number, key: CacheType): number => {
        return prev + (this.allocatedMemory[key] ?? 0);
      },
      0,
    );
  }
}
